import { withSuspenseLazy } from 'react-with-suspense-lazy';

import { RoutesConfiguration } from '@components/RouterOutlet';
import { permissionsRoles } from '@config/permissions';
import { Loader } from '@components/Loader';

import { SerieRoutePaths } from '../routesPaths';

const SeriePage = withSuspenseLazy(
  () => import('./SeriePage'),
  Loader,
);

const SerieAdd = withSuspenseLazy(
  () => import('./SerieAdd'),
  Loader,
);

const SerieEdit = withSuspenseLazy(
  () => import('./SerieEdit'),
  Loader,
);

const SerieBooks = withSuspenseLazy(
  () => import('./SerieBooks'),
  Loader,
);

export const SerieRouteConfig: RoutesConfiguration = [
  {
    path: SerieRoutePaths.serieRoot,
    component: SeriePage,
    exact: true,
    permittedRoles: permissionsRoles.serie,
  },
  {
    path: SerieRoutePaths.serieAddPath,
    component: SerieAdd,
    permittedRoles: permissionsRoles.serie,
  },
  {
    path: SerieRoutePaths.serieEditPath,
    component: SerieEdit,
    permittedRoles: permissionsRoles.serie,
  },
  {
    path: SerieRoutePaths.serieBooksPath,
    component: SerieBooks,
    permittedRoles: permissionsRoles.serie,
  },
];
